import React, { Component } from 'react';
import Select from 'react-select';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';

export class DiscountChangeModal extends Component {
    constructor() {
        super();
        this.state = {
            discount: 0,
            savings: 0,
        }
    }

    componentDidMount() {
        this.setState({ discount: this.props.SODiscount, savings: this.props.SOSavings });
    }

    handleOnConfirm = (e) => {
        e.preventDefault();
        this.props.onDiscountSavingsConfirm(this.state.discount, this.state.savings);
    }

    onChangeDiscount = (e) => {
        this.setState({ discount: e.target.value });
    }

    onChangeSavings = (e) => {
        this.setState({ savings: e.target.value });
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm={6}>
                        <label><Translate value="discount" />(%)</label>
                        <Input
                            type="text"
                            value={this.state.discount}
                            onChange={this.onChangeDiscount}
                        />
                    </Col>
                    <Col sm={6}>
                        <label><Translate value="savings" />($)</label>
                        <Input
                            type="text"
                            value={this.state.savings}
                            onChange={this.onChangeSavings}
                        />
                    </Col>
                </Row>
                <Row className="centerStyle" style={{ marginTop: '25px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="primary"
                        onClick={(e) => { this.handleOnConfirm(e); }}
                    >
                        <Translate value="confirm" />
                    </Button>
                </Row>
            </div>
        );
    }
}

export default DiscountChangeModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/discountChangeModal.jsx